import { ref } from 'vue'

/**
 * The screen-wide red flash on a refusal — module state, not a store, so the
 * plain feedback functions can raise it without a Nuxt context and one
 * ErrorFlash mounted in app.vue can watch it from anywhere.
 *
 * A counter, like AttentionGlow's trigger: every increment shows (or restarts)
 * the flash, and the component never has to reset it.
 */
const errorFlashes = ref(0)

export function useScreenFlash() {
  function flashError(): void {
    errorFlashes.value += 1
  }

  return { errorFlashes, flashError }
}
